import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { useNavigate, useParams } from "react-router-dom";
import { handleApiErrors } from "../../Utils/Utils";
import * as XLSX from 'xlsx';
import CustomTextField from "../../Components/Reusable/CustomTextField";
import 'react-datepicker/dist/react-datepicker.css';
import Calanderimg from '../../assets/images/png/fi_12671954.png'
import DatePicker from "react-datepicker";
import CoordinatorService from "../../Services/CoordinatorService";
import { AuthContext } from "../../Context/authContext"
import ApiConstants from "../../Utils/ApiConstant";



const CoordinatorDetails = () => {
    const [data, setData] = useState([]);
    const [coordinatordetails, setCoordinatorDetails] = useState([]);
    const [grandTotal, setGrandTotal] = useState('');
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [termsChecked, setTermsChecked] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { id } = useParams(); // Get package ID from the URL
    const { user } = useContext(AuthContext);

    const handleStartDateChange = (date) => setStartDate(date);
    const handleEndDateChange = (date) => setEndDate(date);

    const CustomDateInput = ({ value, onClick }) => (
        <div className="custom-date-input" onClick={onClick}>
            <input
                type="text"
                placeholder="From"
                value={value}
                readOnly
                className="form-control"
            />
            <img src={Calanderimg} alt="" className="calendar-icon" />
        </div>
    );
    const CustomDateInputTo = ({ value, onClick }) => (
        <div className="custom-date-input" onClick={onClick}>
            <input
                type="text"
                placeholder="To"
                value={value}
                readOnly
                className="form-control"
            />
            <img src={Calanderimg} alt="" className="calendar-icon" />
        </div>
    );

    const fetchData = async () => {
        try {
            const response = await CoordinatorService.getAllPurchaseList(
                id,
                offset,
                limit,
                startDate,
                endDate,
            );
            setData(response.data.orders);
            setGrandTotal(response.data.grandTotal)
            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };



    const getAllCoordinatorDetail = async () => {

        try {
            const response = await CoordinatorService.getAllCoordinatorDetail(id);
            setCoordinatorDetails(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    useEffect(() => {
        if (id) {
            getAllCoordinatorDetail(id);
            fetchData();
        }
    }, [id, offset]);
    useEffect(() => {
        const fetchTransactionsByDate = () => {
            if (startDate || endDate) {
                fetchData(id, startDate, endDate);
            }
        };

        const timeoutId = setTimeout(fetchTransactionsByDate, 500); // Debounce the request

        return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
    }, [startDate, endDate]);
    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const day = String(d.getDate()).padStart(2, '0'); // Add leading zero if needed
        return `${day}-${month}-${year}`;
    };
    const formattedDateOfBirth = formatDate(coordinatordetails.dateOfBirth);


    const exportToExcel = (data, grandTotal, fileName) => {
        if (!data || data.length === 0) {
            toast.info("No data to export");
            return;
        }

        // Create a worksheet from data
        const ws = XLSX.utils.json_to_sheet(data);

        // Define the grand total row
        const grandTotalRow = [
            '', '', '', '', '', '', '', '', '', '', '', '', 'Grand Total', grandTotal
        ];

        // Add grand total row to the end of the sheet
        XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Write the workbook to file
        XLSX.writeFile(wb, fileName);
    };

    const handleExportClick = () => {
        const name = user.name || "";
        const fileName = `${name} Purchase Details.xlsx`;
        exportToExcel(data, grandTotal, fileName);
    };

    const handlePrintBankDetails = () => {
        const printContent = document.createElement('div');
        printContent.innerHTML = `
            <div style="padding: 20px;">
                <h2 style="text-align: center; margin-bottom: 20px;">Bank Details</h2>
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Account Holder Name:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.accountHolderName || '-'}</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Account Number:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.accountNumber || '-'}</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Branch:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.branch || '-'}</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>IFSC Code:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.ifscCode || '-'}</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>Account Type:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.accountType || '-'}</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN No:</strong></td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${coordinatordetails.bankDetails?.panNumber || '-'}</td>
                    </tr>
                </table>
            </div>
        `;

        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Bank Details</title>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };



    return (
        <div>
            <div className="mb-3 d-flex justify-content-between">
                <h1 className="black fs-18 fw-600 mb-0">Coordinator Details</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0"> Coordinator Details</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <h1 className="black fs-18 fw-600 mb-0">Coordinator Details</h1>
                <div className="table_title ps-2">

                    <form className=" mb-4" >
                        <div className="row profile_inputs w-100 mt-4">
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Coordinators Name"
                                    placeholder="Coordinators Name"
                                    value={coordinatordetails.name}
                                    additionalClasses="coprofile_edit"
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Coordinators Email ID"
                                    disabled={true}
                                    value={coordinatordetails.email}
                                    placeholder="email"
                                    additionalClasses="coprofile_edit"
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Coordinators Mobile Number"
                                    placeholder="Coordinators Mobile Number"
                                    disabled={true}
                                    value={coordinatordetails.mobile}
                                    additionalClasses="coprofile_edit"
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Date of Birth"
                                    placeholder="Enter class end date"
                                    additionalClasses="coprofile_edit"
                                    value={formattedDateOfBirth}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Qualification"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.qualification}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Address Line 1"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.addressLineOne}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Address Line 2"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.addressLineTwo}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="State"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.stateName}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="District"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.district}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Taluka"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.taluka}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Pincode"
                                    placeholder="Select"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.pinCode}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>

                            <div className="col-md-6" >
                                <CustomTextField
                                    labelTitle="Coordinators Code"
                                    placeholder="Coordinators Code "
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.referralCode}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6 align-self-center">
                                <div className=' form-check gap-2 d-flex fw-600  py-3 '>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        checked={coordinatordetails.notifyEmail}
                                    />
                                    <label class="form-check-label " for="flexCheckChecked">
                                        <div className=' fw-500  fs-14'>Notify via Email</div>
                                    </label>
                                </div>
                            </div>



                        </div>
                    </form>

                    <h1 className="black fs-18 fw-600 mb-0">Bank Details</h1>
                    <form className=" mb-4" >
                        <div className="row profile_inputs w-100 mt-4">
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Account Holder Name"
                                    placeholder="Account Holder Name"
                                    value={coordinatordetails.bankDetails?.accountHolderName}
                                    additionalClasses="coprofile_edit"
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Account Number"
                                    disabled={true}
                                    value={coordinatordetails.bankDetails?.accountNumber}
                                    placeholder="Account Number"
                                    additionalClasses="coprofile_edit"
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Branch"
                                    placeholder="Branch"
                                    disabled={true}
                                    value={coordinatordetails.bankDetails?.branch}
                                    additionalClasses="coprofile_edit"
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="IFSC Code"
                                    placeholder="IFSC Code"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.bankDetails?.ifscCode}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Account Type"
                                    placeholder="Account Type"
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.bankDetails?.accountType}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="PAN No."
                                    placeholder="PAN No."
                                    additionalClasses="coprofile_edit"
                                    value={coordinatordetails.bankDetails?.panNumber}
                                    disabled={true}
                                    style={{ backgroundColor: "#E9E9E9" }}
                                />
                            </div>
                            <div className="col-md-6 ">
                                <label htmlFor="chequeimg" className="d-block mb-2 fw-500">Cancelled Cheque Image</label>
                                <a
                                    href={ApiConstants.FILE_FETCH_URL + coordinatordetails.bankDetails?.cancelledChequeImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary "
                                >
                                    View
                                </a>
                            </div>
                          

                        </div>
                        {/* <div className="col-md-12">
                                <h1 className="black fs-18 fw-600 mb-0 d-flex justify-content-center gap-3 align-items-center">
                                Print Bank Details
                                    <button
                                        onClick={handlePrintBankDetails}
                                        className="btn btn-primary d-flex align-items-center gap-2"
                                    >                                       
                                        Print
                                    </button>
                                </h1>
                            </div> */}
                    </form>
                    <div className="detailspurchasepckg pt-4">
                        <div className="" style={{ display: "block" }}>

                            <div className=" row table_title responsivedetailpack align-items-center">

                                <div className="col-md-7 col-12">
                                    <h1 className="black fs-18 fw-600 mb-0">Details of Package Purchased</h1>
                                </div>
                                <div className="col-md-5 col-12 rightsidesec d-flex gap-2 align-items-center justify-content-end datepickerstyle">
                                    <div className="">Date:</div>
                                    <div className="w-25">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            selectsStart
                                            startDate={startDate}
                                            endDate={endDate}
                                            dateFormat="yyyy-MM-dd"
                                            isClearable
                                            placeholderText="From"
                                            maxDate={new Date()}
                                            customInput={<CustomDateInput />}
                                        />
                                    </div>
                                    <div className="w-25">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            selectsEnd
                                            startDate={startDate}
                                            endDate={endDate}
                                            dateFormat="yyyy-MM-dd"
                                            isClearable
                                            placeholderText="To"
                                            minDate={startDate}
                                            maxDate={new Date()}
                                            customInput={<CustomDateInputTo />}
                                        />
                                    </div>
                                    <div className="">
                                        <ButtonWithIcon
                                            text={"Export"}
                                            icon={PngImages.xlspic}
                                            onClick={handleExportClick}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div style={{ overflowX: "auto" }}>
                                <table
                                    className="table mb-0"
                                    id="dtHorizontalExample"
                                    cellSpacing="0"
                                    width="100%"
                                >
                                    <thead>
                                        <tr className="table_heading">
                                            <th scope="col" style={{ width: "10%" }}>
                                                Sr No.
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Student Name
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Email ID
                                            </th>
                                            <th scope="col" style={{ width: "30%" }}>
                                                School Name
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Class
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Package Name
                                            </th>
                                            {/* <th scope="col" style={{ width: "10%" }}>
                                                Price
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Discount in %
                                            </th> */}
                                            <th scope="col" style={{ width: "10%" }}>
                                                Commission in %
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Commission Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg_light">
                                        {data?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{limit * offset + (index + 1)}</td>
                                                <td className="white-space">{item.studentName}</td>
                                                <td className="white-space" >{item.email}</td>
                                                <td className="white-space" >{item.schoolName}</td>
                                                <td>{item.class}</td>
                                                <td className="white-space">{item.packageName}</td>
                                                {/* <td>{item.price}</td>
                                                <td>{item.discountPer}</td> */}
                                                <td>{item.coordinatorPer}</td>
                                                <td>{item.commissionAmt}</td>
                                            </tr>

                                        ))}
                                    </tbody>

                                </table>


                            </div>

                            <div className=" row py-4 mx-0 " style={{ backgroundColor: "#F0F6FF" }}>
                                <div className="col-lg-12 col-12 d-flex text-end float-end fs-18 primary fw-600 justify-content-end">Grand Total&nbsp;:<span>&nbsp;{grandTotal}</span></div>
                            </div >
                            {generatePaginationFooter(
                                availableDataCount,
                                limit,
                                offset,
                                setOffset
                            )}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default CoordinatorDetails;
